import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "item", "section", "intro", "empty"];

  connect() {
    this.filter();
  }

  jump(event) {
    const target = document.getElementById(event.currentTarget.hash.slice(1));
    if (!target) return;

    event.preventDefault();
    this.inputTarget.value = "";
    this.filter();

    window.history.pushState(null, "", event.currentTarget.hash);
    requestAnimationFrame(() => {
      target.tabIndex = -1;
      target.focus({ preventScroll: true });
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }

  filter() {
    const query = this.inputTarget.value.trim().toLocaleLowerCase();
    let visibleCount = 0;

    this.itemTargets.forEach((item) => {
      const matches = !query || item.textContent.toLocaleLowerCase().includes(query);
      item.classList.toggle("hidden", !matches);
      if (matches) visibleCount += 1;
    });

    this.sectionTargets.forEach((section) => {
      section.classList.toggle(
        "hidden",
        !Array.from(section.querySelectorAll('[data-help-search-target="item"]')).some(
          (item) => !item.classList.contains("hidden"),
        ),
      );
    });

    if (this.hasIntroTarget) this.introTarget.classList.toggle("hidden", !!query);
    this.emptyTarget.classList.toggle("hidden", visibleCount > 0);
  }
}
